/**
 * Internet Celebrity Wall -- horizontal auto-scroll carousel.
 *
 * Smoothness: rAF-driven, frame-rate independent (px/sec), with sub-pixel
 * accumulation so the browser doesn't see fractional scrollLeft writes and
 * stair-step the motion. Visibility check uses IntersectionObserver instead
 * of a window scroll listener.
 *
 * Speed equivalence: old code did 1.5px every 50ms = 30px/sec; same target here.
 */

// 接近视口时再挂载封面；鼠标/触屏直接进入也立即补齐，不改播放器和弹窗逻辑。
(function () {
  const selector = '.internetCelebrityWall .videoBox';
  function hydrate(box) {
    const template = box && box.querySelector('template[data-wall-video]');
    if (!template) return;
    template.replaceWith(template.content.cloneNode(true));
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        hydrate(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '800px' }) : null;
  function init(root) {
    root.querySelectorAll(selector).forEach(box => observer ? observer.observe(box) : hydrate(box));
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (observer) event.target.querySelectorAll(selector).forEach(box => observer.unobserve(box));
  });
  ['pointerover', 'focusin', 'touchstart', 'click'].forEach(type => document.addEventListener(type, event => {
    const item = event.target.closest && event.target.closest('.internetCelebrityWall .item');
    if (item) hydrate(item.querySelector('.videoBox'));
  }, { passive: true, capture: true }));
})();

function autoScrollInit (selector) {
  const el = document.querySelector(selector);
  if (!el) return;

  const PX_PER_SEC = 30;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  const RESUME_DELAY_MS = 2500;

  let inView = false;
  let paused = false; // covers both desktop hover and touch-interaction
  let resumeTimer = 0;
  let accum = 0;
  let lastTime = 0;

  function scheduleResume () {
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function () { paused = false; }, RESUME_DELAY_MS);
  }

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          inView = entry.intersectionRatio >= 0.99;
        });
      },
      { threshold: [0.99] }
    );
    io.observe(el);
  } else {
    const onScroll = function () { inView = isElementInViewport(el); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  el.addEventListener('mouseenter', function () { paused = true; clearTimeout(resumeTimer); });
  el.addEventListener('mouseleave', function () { paused = false; });

  // Touch: pause the moment the finger lands so horizontal swipe-to-browse
  // doesn't fight the autoscroll. Resume after a short idle window post
  // release, so an accidental brush during vertical page scroll doesn't
  // freeze the carousel permanently.
  el.addEventListener('touchstart', function () { paused = true; clearTimeout(resumeTimer); }, { passive: true });
  el.addEventListener('touchend', scheduleResume, { passive: true });
  el.addEventListener('touchcancel', scheduleResume, { passive: true });

  function step (time) {
    if (lastTime === 0) lastTime = time;
    // Cap dt so tab-switch / long pause doesn't produce a giant jump.
    const dt = Math.min(time - lastTime, 100);
    lastTime = time;

    if (inView && !paused && !el.classList.contains('dragging')) {
      accum += (PX_PER_SEC * dt) / 1000;
      const whole = Math.floor(accum);
      if (whole > 0) {
        el.scrollLeft += whole;
        accum -= whole;
      }
    } else {
      // Drop accumulated fraction while paused so resume feels clean.
      accum = 0;
    }

    requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

function touchEventInit (event) {
  const $container = $(event);
  let isDragging = false;
  let startX, startY, startScrollLeft, startScrollTop;

  $container.on('mousedown', function (e) {
    isDragging = true;
    $container.addClass('dragging');
    startX = e.pageX;
    startY = e.pageY;
    startScrollLeft = $container.scrollLeft();
    startScrollTop = $container.scrollTop();
    e.preventDefault();
  });

  $container.on('mousemove', function (e) {
    if (!isDragging) return;
    const deltaX = e.pageX - startX;
    const deltaY = e.pageY - startY;
    $container.scrollLeft(startScrollLeft - deltaX);
    $container.scrollTop(startScrollTop - deltaY);
  });

  $container.on('mouseup mouseleave', function () {
    if (!isDragging) return;
    isDragging = false;
    $container.removeClass('dragging');
  });
};

if (autoplay) {
  autoScrollInit('.internetCelebrityWall .videoSlider');
}

touchEventInit($(".internetCelebrityWall .videoSlider"));

$('.internetCelebrityWall .videoSlider .item .itemBox .videoBox, .internetCelebrityWall .videoSlider .item .itemBox .btn').on('click', function (event) {
  event.stopPropagation();
  event.preventDefault();
  const currentItem = $(this).closest(".item");
  currentItem.find("video")[0].pause();

  internetCelebrityWallPopupOpen(sectionId, $(this).closest('.item').index() + 1);
})

// 延后插入的视频也要绑定原有悬停播放；该媒体事件不冒泡，使用捕获监听。
document.addEventListener('canplaythrough', function (event) {
  const video = event.target;
  if (!video.matches('.internetCelebrityWall .videoSlider .item video') || video.dataset.wallPlaybackBound) return;
  video.dataset.wallPlaybackBound = 'true';
  bindWallPlayback.call(video);
}, true);
function bindWallPlayback () {
  var isPlay = false;
  $(this)
    .closest(".item")
    .on("mouseover", function () {
      $(this).find("video")[0].play();
    });
  $(this)
    .closest(".item")
    .on("mouseout", function () {
      $(this).find("video")[0].pause();
    });
  $(this).on("play", function () {
    isPlay = true;
  });

  $(this).on("pause", function () {
    isPlay = false;
  });
}

$(
  ".internetCelebrityWall .videoSlider .item"
).hover(function () {
  $(this).find("video")[0].pause();
});
